import { keyframes } from '@mui/system';
import { styled } from '@mui/material/styles';
import { dataTypeConstant } from "../config/constant";
import { store } from "../redux/store";
import { toast } from 'react-toastify';
import html2canvas from "html2canvas";
import { jwtDecode } from "jwt-decode";
import moment from 'moment';


export const storageGetItem = (name) => {
    return window.localStorage.getItem(name);
}

export const storageSetItem = (name, data) => {
    window.localStorage.setItem(name, data);
}

export const storageRemoveItem = (name) => {
    window.localStorage.removeItem(name);
}


export const getAccessToken = () => {
    const authToken = storageGetItem('token');
    if (authToken !== "" && authToken !== null && authToken !== undefined) {
        return authToken;
    }
    return false;
}

export const getBusinessId = () => {
    if (getAccessToken()) {
        const decoded = jwtDecode(getAccessToken());
        if (decoded?.businessId) {
            return parseInt(decoded?.businessId);
        }
    }
    return false;
}

export const getBusinessName = () => {
    if (getAccessToken()) {
        const decoded = jwtDecode(getAccessToken());
        if (decoded?.name) {
            return decoded?.name;
        }
    }
    return false;
}

export const getUserId = () => {
    if (getAccessToken()) {
        const decoded = jwtDecode(getAccessToken());
        if (decoded?.id) {
            return parseInt(decoded?.id);
        }
    }
    return false;
}

export const getRoleId = () => {
    const roleId = storageGetItem('roleId');
    if (roleId !== "" && roleId !== undefined) {
        return roleId;
    }
    return false;
}

export const getLoginAccessToken = () => {
    const authToken = storageGetItem('loginToken');
    if (authToken !== "" && authToken !== undefined) {
        return authToken;
    }
    return false;
}


export const checkNewUser = () => {
    const isNewUser = storageGetItem('isNewUser');
    if (isNewUser !== "" && isNewUser !== undefined) {
        return isNewUser;
    }
    return false;
}


export const checkEvent = () => {
    const event = storageGetItem('event');
    if (event !== "" && event !== undefined) {
        return event;
    }
    return false;
}

export const checkProductSearch = () => {
    const productSearch = storageGetItem('productSearch');
    return productSearch || 'standard';
}

export const checkBillProductView = () => {
    const productView = storageGetItem('billProductView');
    return productView || 'description';
}

export const checkQuoteProductView = () => {
    const productView = storageGetItem('quoteProductView');
    return productView || 'description';
}

export const checkPosProductView = () => {
    const productView = storageGetItem('posProductView');
    return productView || 'description';
}


export const checkDocumentProductView = () => {
    const productView = storageGetItem('documentProductView');
    return productView || 'description';
}

export const checkDocumentQuoteView = () => {
    const productView = storageGetItem('documentQuoteView');
    return productView || 'description';
}

export const checkDocumentPosView = () => {
    const productView = storageGetItem('documentPosView');
    return productView || 'description';
}

export const checkTypeSearch = () => {
    const typeSearch = storageGetItem('posSearchType');
    return typeSearch || 'All';
}

export const isLoggedIn = () => {
    let j = getAccessToken();
    if (j) {
        return true;
    }
    return false;
}

export const checkLogin = (props) => {
    let j = getAccessToken();
    let n = checkNewUser();
    if (j && n === true) {
        props.history.push(`/change-password`);
    } else if (j) {
        props.history.push(`/`);
    }
    return false;
}

export const checkLoginPassword = (props) => {
    let j = getLoginAccessToken();
    if (j) {
        props.history.push(`/change-password`);
    } else {
        props.history.push(`/`);
    }
    return false;
}


// Raised when the desktop app declines to log out; LogoutGuard (src/data) shows why.
export const LOGOUT_BLOCKED_EVENT = 'younote:logout-blocked';

// Raised on the desktop when the server rejects the session (401); ReauthDialog (src/data)
// lets the same user sign in again without leaving the screen they are on.
export const SESSION_EXPIRED_EVENT = 'younote:session-expired';

export const logoutUser = async (props, { acknowledgeDataLoss = false } = {}) => {
    const desktopData = typeof window !== 'undefined' && window.electron && window.electron.data;
    if (desktopData) {
        // Explicit logout erases this computer's business data and credential vault: the
        // local store is not yet scoped per business, so anything left behind would be
        // readable by the next person to sign in. The main process refuses while changes are
        // unsent. Idle timeout (same user) does not come here and keeps everything.
        let result;
        try {
            result = await desktopData.resetForLogout({ acknowledgeDataLoss });
        } catch (e) {
            result = { ok: false, reason: 'error', message: e && e.message };
        }
        if (!result || !result.ok) {
            window.dispatchEvent(new CustomEvent(LOGOUT_BLOCKED_EVENT, { detail: result || { reason: 'error' } }));
            return false;
        }
        // Setup was reset, so the first-run wizard downloads data again for the next user.
        window.localStorage.setItem('setup_completed', 'false');
    }
    removeAllStorage();
    window.location.href = "/login";
    return true;
}

export const logoutUserIdle = (props) => {
    removeAllStorage();
    props.history.push(`/`);
}

export const removeAllStorage = () => {
    storageRemoveItem('token');
    storageRemoveItem('businessType');
    storageRemoveItem('isPaying');
    storageRemoveItem('deviceToken');
    storageRemoveItem('isNewUser');
    storageRemoveItem('loginToken');
    storageRemoveItem('businessId');
    storageRemoveItem('userId');
    storageRemoveItem('roleId');
    storageRemoveItem('event');
    storageRemoveItem('languageId');
    storageRemoveItem('productSearch');
    storageRemoveItem('purchaseView');
    storageRemoveItem('salesView');
}

export const isExpired = () => {
    removeAllStorage();
    window.location.href = "/login?status=expired";
    return false;
}

export const capitalizeFirstLetter = (string) => {
    return string && string[0].toUpperCase() + string.slice(1).toLowerCase();
}


export const currencyFormat = (amount) => {
    return (parseFloat(amount)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export const currencyFormatInt = (amount) => {
    return parseInt(Math.round(amount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Up to 2 decimals (quantities can be fractional, e.g. kg), trailing zeros dropped, comma grouped
export const quantityFormat = (quantity) => {
    return parseFloat((parseFloat(quantity) || 0).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


const blink = keyframes`from { opacity: 0; } to { opacity: 1; }`;

export const BlinkedBox = styled('span')({
    animation: `${blink} 1.5s linear infinite`,
});


export const groupBy = (objectArray, property) => {
    if (objectArray.length > 0) {
        return objectArray.reduce((acc, obj) => {
            const key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            // Add object to list for given key's value
            acc[key].push(obj);
            return acc;
        }, {});
    }
}

export const removeCommaString = (value) => {
    let str = '';
    value.map((data, i) => {
        return str += data.lineNumber + ','
    });
    return str.slice(0, -1);
}

export const calculateCGSTTotal = (gstGroup, k) => {
    let g = 0;
    Object.entries(gstGroup).map(([key, value]) => {
        return g += value.reduce((a, v) => a = a + v.cgst, 0);
    });
    return currencyFormat(g);
}
export const calculateSGSTTotal = (gstGroup, k) => {
    let g = 0;
    Object.entries(gstGroup).map(([key, value]) => {
        return g += value.reduce((a, v) => a = a + v.sgst, 0);
    });
    return currencyFormat(g);
}

export const calculateIGSTTotal = (gstGroup, k) => {
    let g = 0;
    Object.entries(gstGroup).map(([key, value]) => {
        return g += value.reduce((a, v) => a = a + v.igst, 0);
    });
    return currencyFormat(g);
}

export const calculateGSTTotal = (gstGroup, k) => {
    let a = 0;
    Object.entries(gstGroup).map(([key, value]) => {
        return a = a + parseFloat(value.reduce((a, v) => a = a + v.gstAmount, 0));
    });
    return currencyFormat(a);
}

var XLSX = require("xlsx");
export const exportCommonFile = (title, details, type = 'existing', selected = [], extension = 'xlsx', exportType = 'export') => {
    let heads = [];
    const a = dataTypeConstant.filter(el => { return el.id === title });
    if (a.length !== 0) {
        heads = a[0].fieldList;
    }
    let newArray = [];
    let newHead = [];
    if (selected.length > 0) {
        heads.filter((el) => { return selected.find(e => e === el.key) }).map((h, k) => {
            return newHead[k] = h.key;
        });
    } else {
        heads.map((h, k) => {
            return newHead[k] = h.key;
        });
    }
    newArray[0] = newHead;
    let headMap = heads;
    if (selected.length > 0) {
        headMap = heads.filter((el) => { return selected.find(e => e === el.key) });
    }

    if (type === 'existing') {
        details?.length > 0 && details.map((detail, i) => {
            newHead = [];
            headMap.map((h, k) => {
                if (h.relation || h.exportRelation) {
                    if (h.joinRelation) {
                        // apiField holds an array (eg. batchDetails) - flatten the relation across every
                        // entry so the column exports as a readable list instead of a blank cell.
                        return newHead[k] = Array.isArray(detail[h.apiField])
                            ? detail[h.apiField].map(el => el && el[h.relation]).filter(Boolean).join(', ')
                            : '';
                    }
                    if (h.secondField) {
                        if (h.extraRelation) {
                            return newHead[k] = detail[h.apiField] && detail[h.apiField][h.relation] ? detail[h.apiField][h.relation][h.extraRelation] : (detail[h.secondField][h.relation][h.extraRelation] ? detail[h.secondField][h.relation][h.extraRelation] : '');
                        } else {
                            return newHead[k] = detail[h.apiField] && detail[h.apiField][h.relation] ? detail[h.apiField][h.relation] : (detail[h.secondField] && detail[h.secondField][h.relation] ? detail[h.secondField][h.relation] : '');
                        }
                    } else {
                        if (h.exportRelation && exportType === 'export') {
                            return newHead[k] = detail[h.apiField] && detail[h.apiField][h.exportRelation] ? detail[h.apiField][h.exportRelation] : '';
                        } else {
                            return newHead[k] = detail[h.apiField] && detail[h.apiField][h.relation] ? detail[h.apiField][h.relation] : '';
                        }
                    }
                } else {
                    if (h?.calculation) {
                        return newHead[k] = typeof detail[h.apiField] !== 'undefined' ? detail[h.apiField].reduce((a, v) => a = a + v.quantity, 0) : '';
                    } else if (h?.type && h?.type === 'date') {
                        return newHead[k] = typeof detail[h.apiField] !== 'undefined' ? (detail[h.apiField] ? moment(detail[h.apiField]).format('YYYY-MM-DD') : '') : '';
                    } else if (h?.type && h?.type === 'time') {
                        return newHead[k] = typeof detail[h.apiField] !== 'undefined' ? (detail[h.apiField] ? moment(detail[h.apiField]).format('h:mm:ss') : '') : '';
                    } else if (h?.apiField === 'avgPrice') {
                        return newHead[k] = detail?.purchaseQuantity && detail?.purchaseAmount ? currencyFormat(detail?.purchaseAmount / detail?.purchaseQuantity) : '';
                    } else if (h?.apiField === 'stockValue') {
                        return newHead[k] = detail?.purchaseAmount && detail?.purchaseQuantity ? currencyFormat(((detail?.purchaseQuantity || 0) - (detail?.soldQuantity || 0)) * (detail?.purchaseAmount / detail?.purchaseQuantity)) : '';
                    } else if (h?.apiField === 'discount') {
                        return newHead[k] = (detail.discountAmount || detail.discountPercent) ?
                            (detail.quantity < 0 ?
                                ((parseFloat(detail?.discountAmount || 0) - parseFloat(((detail.quantity * detail.pricePerUnit) * (detail?.discountPercent || 0)) / 100))) :
                                ((parseFloat(detail?.discountAmount || 0) + parseFloat(((detail.quantity * detail.pricePerUnit) * (detail?.discountPercent || 0)) / 100))))
                            : 0;
                    } else {
                        return newHead[k] = typeof detail[h.apiField] !== 'undefined' || detail[h.apiField] !== null ? detail[h.apiField] ? detail[h.apiField] : detail[h.apiSecondField] ? detail[h.apiSecondField] : '' : '';
                    }
                }
            });
            return newArray[i + 1] = newHead;
        });
    }
    const ws = XLSX.utils.aoa_to_sheet(newArray);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    XLSX.writeFile(wb, `${title}.${extension}`);
}

export const exportChatFile = (title, newHead) => {
    const ws = XLSX.utils.aoa_to_sheet(newHead);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    XLSX.writeFile(wb, `${title}.csv`);
}

export const handleHeight = (classes) => {
    if (document.getElementById('containerDiv') !== null) {
        let gH = 0;
        let tH = 0;
        let wH = window.innerHeight;
        setTimeout(() => {
            var greyContents = document.querySelectorAll(`.${classes.customAccrodinContent}`);
            var greyHeadings = document.querySelectorAll(`.${classes.customAccrodinHeader}`);
            let cH = 0;
            greyHeadings.forEach((greyHeading, i) => {
                gH += greyHeading.offsetHeight;
            });
            greyContents.forEach((greyContent, i) => {
                cH = greyHeadings[i].offsetHeight + cH;
                //   let headHeight = wH - (cH + 170);
                greyContent.style.height = 'auto';
                let h = greyContent.offsetHeight;
                // if (headHeight > h || title === 'Minimum Stock Quantity') {
                //     greyContent.style.height = h + 'px';
                // } else {
                //     greyContent.style.height = headHeight + 'px';
                // }
                tH += h;
                //  greyContent.style.height = h + 'px';
                //greyContent.style.height = (wH - cH - 163) + 'px';
                if (i !== 0) {
                    greyContent.style.height = (wH - cH - 163) + 'px';
                } else {
                    greyContent.style.height = h + 'px';
                }
                //greyContent.style.height = (wH - cH - 163) + 'px';
            });

            let lastContent = greyContents && greyContents?.length > 0 ? greyContents[greyContents.length - 1]?.offsetHeight : 0;
            let lastHeader = greyHeadings && greyHeadings?.length > 0 ? greyHeadings[greyHeadings.length - 1]?.offsetHeight : 0;
            tH += gH + 167;

            let pH = (wH - gH - 163 - lastContent - lastHeader);
            if (parseInt(tH) < parseInt(wH)) {
                if (document.getElementById('containerDiv') && document.getElementById('containerDiv').parentElement) {
                    // document.getElementById('containerDiv').parentElement.classList.remove(classes.scrollBorder);
                }
            } else {
                if (document.getElementById('containerDiv') && document.getElementById('containerDiv').parentElement) {
                    document.getElementById('containerDiv').parentElement.classList.add(classes.scrollBorder);
                }
            }
            if (document.getElementById('containerDiv')) {
                document.getElementById('containerDiv').style.paddingBottom = pH + 'px';
            }
        }, 100)
    }
};


// export const Socket = (url) => {
//     const [isReady, setIsReady] = useState(false);
//     const [val, setVal] = useState(null);
//     const ws = useRef(null);

//     useEffect(() => {
//         const socket = new WebSocket(url);
//         socket.onopen = () => { setIsReady(true); };
//         socket.onclose = () => { setIsReady(false); };
//         socket.onmessage = (event) => setVal(event.data);
//         ws.current = socket;
//         return () => {
//             socket.close();
//         };
//     }, []);
//     // bind is needed to make sure `send` references correct `this`
//     return [isReady, val, ws.current?.send.bind(ws.current)];
// };



export const checkPermission = (name, module) => {
    let roles = store?.getState()?.authReducer?.roleManagement;
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    if (roles !== '') {
        let features = roles?.featurePermissions?.filter((el) => { return el?.feature?.uiLabel?.trim() === name?.trim() && el?.feature?.module?.module === module?.trim() });
        if (features?.length > 0) {
            if (features[0].create === false && features[0].edit === false && features[0].view === false && features[0].deletable === false) {
                return false;
            } else {
                return true
            }
        }
    }
    return false;
}

export const checkModulePermission = (name) => {
    let roles = store?.getState()?.authReducer?.roleManagement;
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    if (roles !== '') {
        let modules = roles?.featurePermissions?.filter((el) => { return el?.feature?.module?.module?.trim() === name?.trim() });
        if (modules?.length > 0) {
            let a = modules?.filter((el) => {
                return el?.create || el?.edit || el?.view || el?.deletable
            });
            if (a?.length > 0) {
                return true
            }
        }
    }
    return false;
}

export const checkModuleViewPermission = (name, history) => {
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    if (checkModulePermission(name) === false) {
        toast.dismiss();
        toast.error('Access Denied. Please contact Administrator');
        history.push("/");
    } else {
        return true;
    }
}


export const checkCRUDPermission = (name, data, module) => {
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    let roles = store?.getState()?.authReducer?.roleManagement;
    if (roles !== '') {
        let features = roles?.featurePermissions?.filter((el) => { return el?.feature?.uiLabel?.trim() === name?.trim() && el?.feature?.module?.module === module?.trim() });
        if (features?.length > 0) {
            return features[0][data];
        }
        return false
    }
    return false
}

export const checkCRUDViewPermission = (name, data, history, module) => {
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    if (checkCRUDPermission(name, data, module) === false) {
        toast.dismiss();
        toast.error('Access Denied. Please contact Administrator');
        history.push("/");
    } else {
        return true;
    }
}



export const checkViewPermission = (name, history, module) => {
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    if (checkPermission(name, module) === false) {
        toast.dismiss();
        toast.error('Access Denied. Please contact Administrator');
        history.push("/");
    } else {
        return true;
    }
}


export const checkComponentPermission = (feature, type, name) => {
    // if (AESDecrypt(storageGetItem('roleName')) === 'Younote Admin') {
    //     return true;
    // }
    let roles = store?.getState()?.authReducer?.roleManagement;
    if (roles !== '' && roles?.componentPermissions) {
        let a = roles?.componentPermissions?.filter((el) => {
            return el?.component?.feature?.uiLabel?.trim() === feature?.trim() &&
                el?.component?.componentType?.componentType?.trim() === type?.trim() &&
                el?.component?.component?.trim() === name?.trim()
        });
        if (a.length > 0) {
            return a[0].enabled
        }
    }
    return false
}


export const downloadImageCommon = (element, title, type) => {
    document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    const fakeDiv = window.document.createElement("div");
    document.body.appendChild(fakeDiv);
    fakeDiv.innerHTML = element.innerHTML;
    fakeDiv.className = "downloadPng";
    fakeDiv.style.padding = "20px";
    fakeDiv.style.width = "600px";
    html2canvas(fakeDiv, fakeDiv.style.display = "block").then(canvas => {
        canvas.getContext('2d');
        const image = canvas.toDataURL(`image/${type}`);
        const fakeLink = window.document.createElement("a");
        fakeLink.style = "display:none;";
        fakeLink.download = `${title}.${type}`;
        fakeLink.href = image;
        document.body.appendChild(fakeLink);
        fakeLink.click();
        document.body.removeChild(fakeLink);
        fakeLink.remove();
        fakeDiv.remove();
        document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    });
};


export const numDifferentiation = (value) => {
    const val = Math.abs(value)
    if (val >= 10000000) return `${(value / 10000000)} C`
    if (val >= 100000) return `${(value / 100000)} L`
    if (val >= 1000) return `${(value / 1000)} K`
    return value;
}


export const scrollToError = () => {
    setTimeout(() => {
        let error = document.querySelectorAll(`.customFormFlex .Mui-error`);
        if (error.length > 0) {
            error[0].closest('.ant-col').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, 100);
}


export const scrollToErrorSidebar = (classes) => {
    setTimeout(() => {
        let error = document.querySelectorAll(`.${classes.customFormFlex} .Mui-error`);
        if (error.length > 0) {
            error[0].closest('.ant-col').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, 100);
}


export const getColumnLocalStorage = () => {
    const columnsInfo = storageGetItem('columnsInfo');
    if (columnsInfo !== "" && columnsInfo !== undefined) {
        return JSON.parse(columnsInfo);
    }
    return false;
}


export const getColumnWidth = (heads, index, name = '') => {
    let w = '';
    if (getColumnLocalStorage() !== null) {
        w = getColumnLocalStorage()[heads[index]?.name]
    } else {
        w = (window.innerWidth / (heads.length + (heads.length / 2))) + 'px';
    }
    return w;
}

export const openBase64NewTab = (base64Pdf) => {
    var blob = base64toBlob(base64Pdf);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, "pdfBase64.pdf");
    } else {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
    }
}

export const base64toBlob = (base64Data) => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: "application/pdf" });
}

export const nextInputFocus = (e) => {
    const currentNode = e.target;
    //find all tab-able elements
    const allElements = document.querySelectorAll('input, button, a, area, object, select, textarea, [contenteditable]');
    //Find the current tab index.
    const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el))
    //focus the following element
    const targetIndex = (currentIndex + 1) % allElements.length;
    allElements[targetIndex].focus();
}

export const prevInputFocus = (e) => {
    const currentNode = e.target;
    //find all tab-able elements
    const allElements = document.querySelectorAll('input, button, a, area, object, select, textarea, [contenteditable]');
    //Find the current tab index.
    const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el))
    //focus the following element
    const targetIndex = (currentIndex - 1) % allElements.length;
    allElements[targetIndex].focus();
}

export const secondsToHms = (d) => {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
    return hDisplay + mDisplay + sDisplay;
}


export const calculateGrandTotal = (details = {}) => {
    const { selfBillItems = [], cashDiscountId, priceIncludesTax, taxCodeId } = details;

    if (!selfBillItems.length) {
        return {
            total: 0,
            totalInvoice: 0,
            totalDiscount: 0,
            gstAmount: 0,
            netAmount: 0,
            excisesAmount: 0,
            assessableValue: 0,
            tax: 0,
            tcs: 0,
            cashDiscountAmount: 0
        };
    }

    console.log(details);
    /* Base totals */
    const total = selfBillItems.reduce((a, v) => a + (v.amount || 0), 0);

    const discount = selfBillItems.reduce((a, v) => a + parseFloat(v?.discountAmount || 0), 0);

    const discountPercent = selfBillItems.reduce((a, v) => {
        const percentValue = ((v.quantity * v.pricePerUnit) * parseFloat(v?.discountPercent || 0)) / 100;
        return v.amount < 0 ? a - percentValue : a + percentValue;
    }, 0);

    const gst = selfBillItems.reduce((a, v) => a + parseFloat(v?.gstAmount || 0), 0);
    /* Excises */
    const excisesAmount = selfBillItems.reduce((a, v) => a + parseFloat(v?.excisesTotal || 0), 0);
    /* Cash Discount */
    let cashDiscountAmount = 0;
    if (cashDiscountId) {
        const data = details?.cashDiscount || [];
        if (data) {
            cashDiscountAmount = (total * (data.percentage || 0)) / 100;
        }
    }

    /* Assessable */
    let assessableAmount = total - cashDiscountAmount + excisesAmount;

    if (priceIncludesTax) {
        assessableAmount -= gst;
    }

    /* Tax */
    let taxValue = 0;
    if (taxCodeId) {
        const data = details?.taxCode || [];
        if (data) {
            taxValue = (assessableAmount * (data.percentage || 0)) / 100;
        }
    }

    /* TCS */
    let tcsValue = 0;
    if (details?.customer?.tcsBoolean) {
        const tcsBase = assessableAmount + taxValue;
        tcsValue = (tcsBase * (details?.customer?.tcs?.percentage || 0)) / 100;
    }

    /* Final */
    const finalTotal = assessableAmount + taxValue + tcsValue;

    return {
        totalDiscount: parseFloat((discount + discountPercent).toFixed(2)),
        gstAmount: parseFloat(gst.toFixed(2)),
        excisesAmount: parseFloat(excisesAmount.toFixed(2)),
        cashDiscountAmount: parseFloat(cashDiscountAmount.toFixed(2)),
        assessableValue: parseFloat(assessableAmount.toFixed(2)),
        tax: parseFloat(taxValue.toFixed(2)),
        tcs: parseFloat(tcsValue.toFixed(2)),
        netAmount: parseFloat(assessableAmount.toFixed(2)),
        total: parseFloat((finalTotal + gst).toFixed(2)),
        totalInvoice: parseFloat((finalTotal + gst).toFixed(2))
    };
};

export const gstCalculation = (businessDetails, details, supplier = '') => {
    let cgst = 0; let sgst = 0; let igst = 0; let cgstAmount = 0; let sgstAmount = 0; let igstAmount = 0; let gAmount = 0; let cessAmount = 0;
    if (details && details?.priceIncludesTax) {
        if ((businessDetails?.taxType?.taxCode === 'SPEZ' || businessDetails?.taxType?.taxCode === 'NRTP') ||
            (supplier !== '' && (supplier?.taxType?.taxCode === 'SPEZ' || supplier?.taxType?.taxCode === 'NRTP')) || (businessDetails && details.stateId !== businessDetails.stateId)) {
            let taxAmount = 0;
            if (details?.cess) {
                if (details?.cessType === "PERCENTAGE") {
                    let percentage = details.percentage + parseFloat(details?.cessValue || 0);
                    taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat(parseFloat(details?.lineAmount || 0) - (parseFloat(details?.lineAmount || 0) * (100 / (100 + (percentage)))));
                } else {
                    taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat(details?.cessValue || 0);
                    taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat((taxAmount - (taxAmount * (100 / (100 + details.percentage))))) - parseFloat(details.cessValue);
                }
                cessAmount = details?.cessType === "PERCENTAGE" ? parseFloat((taxAmount * parseFloat(details?.cessValue || 0)) / 100).toFixed(2) : details?.cessValue;
            } else {
                let percentage = details.percentage;
                taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat(parseFloat(details?.lineAmount || 0) - (parseFloat(details?.lineAmount || 0) * (100 / (100 + (percentage)))));
            }
            igst = details.percentage;
            igstAmount = parseFloat((taxAmount * details.percentage) / 100).toFixed(2);
            gAmount = parseFloat((taxAmount * details.percentage) / 100).toFixed(2);
        } else if (businessDetails && details.stateId === businessDetails.stateId) {
            let taxAmount = 0;
            if (details?.cess) {
                if (details?.cessType === "PERCENTAGE") {
                    let percentage = details.percentage + parseFloat(details?.cessValue || 0);
                    taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat(parseFloat(details?.lineAmount || 0) - (parseFloat(details?.lineAmount || 0) * (100 / (100 + (percentage)))));
                } else {
                    taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat(details?.cessValue || 0);
                    taxAmount = parseFloat(details.lineAmount) - parseFloat((taxAmount - (taxAmount * (100 / (100 + details.percentage))))) - parseFloat(details.cessValue);
                }
                cessAmount = details?.cessType === "PERCENTAGE" ? parseFloat((taxAmount * details.cessValue) / 100).toFixed(2) : details?.cessValue;
            } else {
                let percentage = details.percentage;
                taxAmount = parseFloat(details?.lineAmount || 0) - parseFloat(parseFloat(details?.lineAmount || 0) - (parseFloat(details?.lineAmount || 0) * (100 / (100 + (percentage)))));
            }
            cgst = parseFloat(details.percentage / 2);
            sgst = parseFloat(details.percentage / 2);
            cgstAmount = parseFloat((taxAmount * (details.percentage / 2)) / 100).toFixed(2);
            sgstAmount = parseFloat((taxAmount * (details.percentage / 2)) / 100).toFixed(2);
            gAmount = parseFloat((taxAmount * details.percentage) / 100).toFixed(2);
        }
    } else {
        if ((businessDetails?.taxType?.taxCode === 'SPEZ' || businessDetails?.taxType?.taxCode === 'NRTP') ||
            (supplier !== '' && (supplier?.taxType?.taxCode === 'SPEZ' || supplier?.taxType?.taxCode === 'NRTP')) || (businessDetails && details.stateId !== businessDetails.stateId)) {
            igst = details.percentage;
            igstAmount = parseFloat((parseFloat(details?.lineAmount || 0) * details.percentage) / 100).toFixed(2);
        } else if (businessDetails && details.stateId === businessDetails.stateId) {
            cgst = parseFloat(details.percentage / 2);
            sgst = parseFloat(details.percentage / 2);
            cgstAmount = parseFloat((parseFloat(details?.lineAmount || 0) * (details.percentage / 2)) / 100).toFixed(2);
            sgstAmount = parseFloat((parseFloat(details?.lineAmount || 0) * (details.percentage / 2)) / 100).toFixed(2);
        }

        if (details?.cess) {
            if (details?.cessType === "PERCENTAGE") {
                cessAmount = parseFloat((parseFloat(details?.lineAmount || 0) * parseFloat(details?.cessValue || 0)) / 100).toFixed(2);
            } else {
                cessAmount = parseFloat(details?.cessValue || 0)
            }
        }

        gAmount = parseFloat((parseFloat(details?.lineAmount || 0) * details.percentage) / 100).toFixed(2);
    }

    return {
        cgst: cgst, igst: igst, sgst: sgst,
        cgstAmount: parseFloat(cgstAmount), sgstAmount: parseFloat(sgstAmount),
        igstAmount: parseFloat(igstAmount), gAmount: parseFloat(gAmount), cessAmount: parseFloat(cessAmount)
    };
}


export const includeGstSettings = (businessDetails, customer) => {
    let includeGst = false; let includeDisabled = true;
    if (businessDetails?.taxType?.taxCode === 'RERB'
        && customer?.taxType?.taxCode === 'RERB') {
        includeGst = true;
        includeDisabled = true;
    } else if (businessDetails?.taxType?.taxCode === 'RERB'
        && customer?.taxType?.taxCode !== 'RERB') {
        includeGst = true;
        includeDisabled = false;
    } else if (businessDetails?.taxType?.taxCode === 'COMP'
        || businessDetails?.taxType?.taxCode === 'UNRB'
        || businessDetails?.taxType?.taxCode === 'CONS') {
        includeGst = false;
        includeDisabled = true;
    } else if (businessDetails?.taxType?.taxCode === 'SPEZ'
        || businessDetails?.taxType?.taxCode === 'NRTP'
        || businessDetails?.taxType?.taxCode === 'CATP') {
        includeGst = true;
        includeDisabled = true;
    }
    return { includeGst: includeGst, includeDisabled: includeDisabled }
}



export const billCalculationWords = (number) => {
    let words = '';

    const numbersToWords = {
        0: '', 1: 'One', 2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five', 6: 'Six', 7: 'Seven', 8: 'Eight', 9: 'Nine', 10: 'Ten',
        11: 'Eleven', 12: 'Twelve', 13: 'Thirteen', 14: 'Fourteen', 15: 'Fifteen', 16: 'Sixteen', 17: 'Seventeen', 18: 'Eighteen', 19: 'Nineteen', 20: 'Twenty',
        30: 'Thirty', 40: 'Forty', 50: 'Fifty', 60: 'Sixty', 70: 'Seventy', 80: 'Eighty', 90: 'Ninety'
    };

    if (number in numbersToWords) {
        return numbersToWords[number];
    }

    // if (number >= 10000000) {
    //     words += billCalculationWords(Math.floor(number / 1000000)) + ' Million ';
    //     number %= 10000000;
    // }
    if (number >= 100000000) {
        let text = Math.floor(number / 10000000) > 9 ? ' Crores ' : ' Crore '
        words += billCalculationWords(Math.floor(number / 10000000)) + '' + text;
        number %= 10000000;
    }

    if (number >= 10000000) {
        let text = Math.floor(number / 10000000) > 9 ? ' Crores ' : ' Crore '
        words += billCalculationWords(Math.floor(number / 10000000)) + '' + text;
        number %= 10000000;
    }

    if (number >= 1000000) {
        let text = Math.floor(number / 100000) > 9 ? ' Lakhs ' : ' Lakh '
        words += billCalculationWords(Math.floor(number / 100000)) + '' + text;
        number %= 100000;
    }

    if (number >= 100000) {
        let text = Math.floor(number / 100000) > 9 ? ' Lakhs ' : ' Lakh '
        words += billCalculationWords(Math.floor(number / 100000)) + '' + text;
        number %= 100000;
    }

    if (number >= 1000) {
        words += billCalculationWords(Math.floor(number / 1000)) + ' Thousand ';
        number %= 1000;
    }

    if (number >= 100) {
        words += billCalculationWords(Math.floor(number / 100)) + ' Hundred ';
        number %= 100;
    }

    if (number > 0) {
        if (words !== '') {
            words += '';
        }
        if (number <= 20) {
            words += numbersToWords[number];
        } else {
            words += numbersToWords[Math.floor(number / 10) * 10] + ' ' + numbersToWords[number % 10];
        }
    }

    return words;
}

export function overAllCalculation(n) {
    let val = parseFloat(n).toFixed(2),
        split = val.toString().split('.'),
        number = Math.abs(split[0]),
        words = number > 0 ? billCalculationWords(number).trim() : 'Zero',
        decimal = Math.abs(split[1]) > 0 ? billCalculationWords(Math.abs(split[1])) : 'Zero';
    return '(' + words + ' Rupees and ' + decimal + ' Paise only)';
}

export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function idNamingConversion(name, place = 'menu', fieldType = '') {
    const list = {
        login: 'LOGIN',
        register: "REG",
        menu: 'ME',
        businessProfile: 'BP',
        customerProfile: 'CP',
        supplierProfile: 'SP',
        burgerMenu: 'BME',
        salesBill: 'SB',
        salesBillLine: 'SBL',
        customerPayment: 'CPMT',
        customerGroup: 'CG',
        customerAgedDues: 'CAD',
        customerLeaderBoard: 'CLB',
        productAnalysis: 'PA',
        salesLocation: 'SL',
        top10Supplier: 'TS',
        salesPrice: 'SPRICE',
        salesDiscount: 'SD',
        purchasePrice: 'PPRICE',
        product: 'PRO',
        productBatch: 'PROB',
        productUnit: 'PROU',
        outBoundPrice: 'OBP',
        teamManagement: 'TM',
        productGroup: 'PG',
        salesQuote: 'SQ',
        salesQuoteLine: 'SQL',
        supplyQuote: 'SUPQ',
        supplyQuoteLine: 'SUPQL',
        customerProductScheduling: 'CPS',
        customerProductSchedulingLine: 'CPSL',
        storeSales: 'SS',
        scheduleTransactions: 'ST',
        storeSalesLine: 'SSL',
        purchaseBill: 'PB',
        purchaseBillLine: 'PBL',
        supplierPayment: 'SP',
        customerTransactions: 'CTS',
        customerInvoiceHistory: 'CIH',
        customerProducts: 'CPS',
        customerProductsLine: 'CPSL',
        pointOfSale: 'POS',
        supplierTransactions: 'STS',
        supplierInvoiceHistory: 'SIH',
        supplierGroup: 'SG',
        stockTransaction: 'STT',
        productUnitConversions: 'PUC',
        billingsPlans: 'BP',
        salesOrder: 'SO',
        quickLink: 'QL',
        dashboard: 'DB',
        notification: 'NC',
        common: 'COMMON',
        storeSalesPaymnet: 'SSP',
        deliveryNoteHistory: 'DNH',
        location: 'LO',
        parameters: 'PARA',
        inventoryTransaction: 'IT',
        stockOnHand: 'SOH',
        adjustStock: 'AS',
        adjustStockLine: 'ASL',
        stockCount: 'SC',
        stockCountLine: 'SCL',
        salesPaymentStatement: 'SPS',
        resaleValue: 'RV',
        gstRecalculation: 'GSTRC'
    };
    const type = {
        TextField: 'TEXT',
        DropDown: 'DD',
        Radio: 'Radio',
        Icon: 'Icon',
        Button: 'Btn',
        Link: 'Link'
    };
    const n = name.replace(/\s+/g, '-').toLowerCase();
    let re = '';
    if (fieldType !== '') {
        re += type[fieldType] + '-';
    }
    re += list[place] + '-';
    return re + '' + n;
}

export function displayPan(panE) {
    // let panArray = [];
    // if (pan) {
    //     panArray = pan.split("-");
    // }

    let identityType = '';
    let pan = '';

    if (panE) {
        const panArray = panE.split('-').map(v => v.trim());

        identityType = panArray[0] || '';
        pan = panArray.slice(1).join('-') || '';
    }


    return [identityType, pan];
}

export function groupByMultiple(objArray, ...props) {
    return objArray.reduce((acc, obj) => {
        const key = props.map(prop => obj[prop]).join('@@@');
        acc[key] = acc[key] || [];
        acc[key].push(obj);
        return acc;
    }, {});
}

// Convert Image to Base64
export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const displayTemplateName = (format) => {
    switch (format) {
        case "format1": return 'BTST';
        case "btst-1": return 'BTST 1';
        case "format5": return 'Format 2';
        case "format7": return 'Format 3';
        case "format9": return 'Format 4';
        case "billSupply": return 'Bill Of Supply';
        case "letter": return 'Letter Head';
        case "SBP": return 'Small Business - Portrait';
        case "SBL": return 'Small Business - Landscape';
        case "EX01": return 'EX-01';
        default: return 'BTST';
    }
}

export const displayQuoteTemplateName = (format) => {
    switch (format) {
        case "quote-GST": return 'GST - Template';
        case "quote-no_GST": return 'No GST - Template';
        case "EX01": return 'EX-01';
        default: return 'GST - Template';
    }
}

export const getUploadedFile = (fileUri) => {
    return process.env.REACT_APP_ASSET_ROOT_URL + '/v1/fileprocessor/getFile/?fileUri=' + fileUri;
}

export const getFileAttachement = (fileUri) => {
    return process.env.REACT_APP_ASSET_ROOT_URL + '/v1/fileprocessor/getFileAsAttachement/?fileUri=' + fileUri;
}

export const getFileAsJson = (fileUri) => {
    return process.env.REACT_APP_ASSET_ROOT_URL + '/v1/fileprocessor/getFileAsJson/?fileUri=' + fileUri;
}

export const pix2mm = (val, dpi) => {
    return (val / 0.01) * 0.0026458333 + 30;
}

export const pix2mmNew = (val, dpi) => {
    return (val / dpi) * 25.4; // 1 inch = 25.4 mm
}

export const downloadTitle = (data, type) => {
    let first = ''; let second = ''; let title = '';
    if (type === 'sales-bill') {
        first = 'Sales Bill'; second = 'Invoice';
    } else if (type === 'supply-bill') {
        first = 'Supply Bill'; second = 'Supply Invoice';
    } else if (type === 'sales-quote') {
        first = 'Quotation'; second = 'Quotation';
    } else if (type === 'sales-order') {
        first = 'Sales Order'; second = 'Sales Order';
    } else if (type === 'supply-quote') {
        first = 'Supply Quote'; second = 'Supply Quote';
    } else if (type === 'supply-order') {
        first = 'Purchase Order'; second = 'Purchase Order';
    }

    if (data?.salesInvoice?.serialNo || data?.purchaseInvoice?.serialNo || data?.purchaseInvoice?.supplierRefNum) {
        title = `${second}-${data?.salesInvoice?.serialNo || data?.purchaseInvoice?.supplierRefNum || data?.purchaseInvoice?.serialNo || ''}`
    } else {
        if (type === 'supply-bill') {
            title = `${first}-${data?.supplierRefNum || data?.serialNo || ''}`
        } else {
            title = `${first}-${data?.serialNo || ''}`
        }
    }

    return title;
}